import { type JSX } from 'react';
import { Badge } from '../badge';
import { useSubscriptionBadgeStyles } from './subscriptionBadge.styles';

export type SubscriptionBadgeProps = {
  content: string;
  active: boolean;
  size?: 'small' | 'large';
};

export const SubscriptionBadge = ({
  content,
  active,
  size = 'small',
}: SubscriptionBadgeProps): JSX.Element => {
  const styles = useSubscriptionBadgeStyles({ active, size });
  return <Badge content={content} css={styles} />;
};
